var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.login)?_c('login'):_vm._e(),(_vm.register)?_c('register'):_vm._e(),(_vm.forgot)?_c('forgot-password'):_vm._e(),(_vm.reset)?_c('reset-password'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }